// Login
export const welcomeBack = 'Welcome back'
export const welcome = 'Welcome'
export const login = 'Login'
export const email = 'Email'
export const password = 'Password'
export const forgotPasswordQuestion = 'Reset Password'
export const capsIsOn = 'Caps Lock is turned on!'
export const ifYouDontHaveAccount = "If you don't have an account -"
export const registerHere = 'Register Here'
export const copyright = 'Copyright'
export const familipay = 'FamilyPay LLC, All rights reserved'

// Demo
export const demo = 'Demo'
export const startDemo = 'Start Demo'
export const demoDisclaimerTitle = 'Demo Environment'
export const demoDisclaimerText = 'This is a demo environment. All of the changes will be lost once you log out. When ready to start using FamiliPay, start a '

// Register
export const register = 'Register'
export const firstName = 'First Name'
export const lastName = 'Last Name'
export const repeatPassword = 'Repeat Password'
export const country = 'Country'
export const referralCode = 'Referral Code'
export const enterReferralCode = 'Enter Your Referral Code'
export const registerAccount = 'Agree and Register'
export const ifYouHaveAccount = 'If you have an account -'
export const loginHere = 'Login Here'
export const enterFirstName = 'Enter Your First Name'
export const enterLastName = 'Enter Your Last Name'
export const enterEmail = 'Enter Your Email'
export const enterPassword = 'Enter Your Password'
export const enterRepeatPassword = 'Repeat Password'
export const enterCountry = 'Select Country'
export const passMsgLabel = 'Password must satisfy following rules'
export const passMsgLength = 'It should be at least 8 characters long and may not be greater than 64 characters'
export const passMsgUppercase = 'It must contain 1 uppercase letter'
export const passMsgLowercase = 'It must contain 1 lowercase letter'
export const passMsgNumber = 'It must contain 1 number'
export const passMsgCharacters = 'It must contain 1 special character'
export const iAgreeLabelFirst = "By signing up you agree to our company"
export const iAgree = 'I agree'
export const termsOfService = 'Terms of Service'
export const privacyPolicy = 'Privacy Policy'
export const and = 'and'

// Forgot Password
export const forgotPassword = 'Reset Password'
export const sendResetEmail = 'Send Reset Email'

// Forgot Password Confirm
export const confirimPassword = 'Confim Password'
export const newPassword = 'New Password'
export const repeatNewPassword = 'Repeat New Password'
export const resetPassword = 'Reset Password'

// Breadcrumb
export const bb_alimony = 'Alimony'
export const bb_childSupport = 'Child Support'
export const bb_sharedExpense = 'Shared Expense'

// App Layout
export const online = 'Online'
export const familyProfile = 'Family Profile'
export const paymentMethods = 'Payment Methods'
export const invisible = 'Invisible'
export const logout = 'Log Out'
export const registrationSteps = 'Registration steps'
export const registrationProgress = 'Account Setup Progress'
export const emailConfirmation = 'Email Confirmation'
export const emailConfirmationText = 'Please check your email and click the confirmation link there'
export const emailConfirmationLink = 'resend confirmation'
export const familyProfileTitle = 'Set up a Profile'
export const setUpFamilyProfile = 'Set up your Co-Parent and children information'
export const paymentMethod = 'Connect Your Bank Account'
export const setUpPaymentMethod = 'Connect with your bank account in order to be able to send and receive funds'
export const oneTimeExpenses = 'One-time Expenses'
export const recurringExpenses = 'Recurring Expenses'
export const subscriptionMethod = 'Subscription Payment Method'
export const subscriptionMethodText = 'Add a subscription payment method'
export const regAccountProgress = 'Account Setup Progress'
export const Of = 'of'
export const invTheCoparent = 'Invite the co-parent'
export const addChildren = 'Add Children'
export const activateSubscription = 'Subscription'
export const addYourBankAccount = 'Add your bank account'
export const schedulePayments = 'Schedule payments'
export const setupParentCalendarSchedule = 'Setup your parenting schedule'
export const transactionsSuspendedModalTextLine1 = 'In order to protect your data, FamiliPay uses identity verification to ensure that our users provide information that is associated with the identity of a real person.'
export const transactionsSuspendedModalTextLine2 = 'In order to verify your identity we require you to provide us with additional information. We have sent you an email with instructions on how you can do that. '
export const transactionsSuspendedModalTextLine3 = 'You can reply to the email and provide us with one of the following:'
export const transactionsSuspendedModalTextBullet1 = "Photo of your driver's licence or passport"
export const transactionsSuspendedModalTextBullet2 = "Photo of a voided check "
export const transactionsSuspendedModalTextBullet3 = "Photo of your last utility bill"
export const resendEmail = 'Resend Email'

// Sidebar
export const dashboard = 'Dashboard'
export const expensesAndPayments = 'Expenses & Payments'
export const allUnpaidExpenses = 'All Unpaid Expenses'
export const support = 'Support'
export const payments = 'Payment Activity'
export const unpaid = 'Unpaid'
export const recurringPayments = 'Recurring Payments'
export const recurring = 'Recurring'
export const oneTimePayments = 'One-time Payments'
export const transactionHistory = 'History'
export const faqSidebar = 'FAQ'

// Dashboard
export const lastPayment = 'Last Payment'
export const nextPayment = 'Next Payment'
export const spousalMaintenanceTitle = 'Spousal Maintenance'
export const childMaintenanceTitle = 'Child Maintenance'
export const reimbursementBalanceTitle = 'Reimbursement Balance'
export const viewSpousalMaintenance = 'View Spousal Maintenance Payments'
export const viewChildMaintenance = 'View Child Maintenance Payments'
export const viewUnpaidExpenses = 'View Unpaid Expenses'
export const expensesUnderDiscussionTitle = 'Expenses Under Discussion'
export const incomingImportantEvents = 'Incoming Important Events'
export const toPay = 'To Pay'
export const toReceive = 'To Receive'
export const forLabel = 'for'
export const toLabel = 'to'
export const fromLabel = 'From'
export const timeline = 'Timeline'
export const events = 'Events'
export const moreMsg = 'more message'
export const fromThisUser = 'from this user'
export const noMsgDashboard = 'No messages info'
export const noMsgDashboardPara = 'You do not have any unread messages from other co-parents. When you have unread messages, you will be able to see them here'
export const noTimelineInfo = 'Nothing yet'
export const noTimelineInfoPara = 'There are no payments in the next 3 weeks. Add a new payment by clicking the "Schedule Payment" button.'

// Payments
export const selectFilters = 'Select Filters'
export const enterNote = 'Enter Note'
export const typeYourComment = 'Type Your Comment'
export const selectType = 'Select Type'
export const surePayment = 'Are you sure you want to mark this as paid'
export const cannotSendFunds = 'You can\'t send funds'
export const notPayor = 'You are not the payor'
export const coparentCannotSendFunds = 'Your Co-Parent can\'t receive funds'
export const fillOutForm = 'You have to fill out the form'
export const alreadyPaidExpense = 'A payment for this expense has already been paid'
// Unpaid Expenses
export const payAllExpenses = 'Pay All Expenses'
export const showFilters = 'Show Filters'
export const hideFilters = 'Hide Filters'
export const recipient = 'Recipient'
export const selectRecipient = 'Select Recipient'
export const selectChildren = 'Select Children'
export const selectChild = 'Select Child'
export const expenseType = 'Expense Type'
export const date = 'Date'
export const from = 'From'
export const to = 'To'
export const amount = 'Amount'
export const clearAllFilters = 'Clear All Filters'
export const applyFilters = 'Apply Filters'
export const wohoo = 'wohoo'
export const noUnpaidExpenses = 'Looks like you don’t have any unpaid expenses.'
export const dontWorry = 'Don’t worry, that is a good thing ;)'
export const expensesSelected = 'Expenses selected'
export const pay = 'Pay'
export const total = 'Total'
export const grandTotal = 'Grand Total'
export const totalToPay = 'Total To Pay'

// Spousal Maintenance, Child Maintenance, Shared Expenses
export const spousalMaintenance = 'Spousal Maintenance'
export const childMaintenance = 'Child Maintenance'
export const sharedExpense = 'Shared Expenses'
export const addOneTimeExpense = 'Add One-time Payment'
export const scheduleRecurringPayment = 'Schedule Recurring Payment'
export const payor = 'Payor'
export const selectPayor = 'Select Payor'
export const paymentStatus = 'Payment Status'
export const selectPaymentStatus = 'Select Payment Status'
export const paymentDate = 'Payment Date'
export const dueDate = 'Due Date'
export const dueDateFrom = 'Due Date From'
export const dueDateTo = 'Due Date To'
export const additionalFilters = 'Additional Filters'
export const discussed = 'Discussed'
export const scheduled = 'Scheduled'
export const notes = 'Notes'
export const attachments = 'Attachments'
export const nothingHere = 'Nothing here?'
export const setUpFirst = 'Looks like you need to set up your expenses first'
export const dontWorrySimpleSteps = 'Don’t worry it’s simple as 1-2-3'
export const addPayment = 'Pay Later'
export const alreadyPaid = 'Already Paid'
export const notePrivate = 'Note'
export const dragAndDrop = 'Drag and drop or'
export const chooseFiles = 'choose your files'
export const payNow = 'Pay Now'
export const selectMe = 'Me'
export const selectCoparents = 'Select Co-Parent(s)'
export const cancel = 'Cancel'
export const dateOfFirstPayment = 'First Payment Date'
export const editDateOfFirstPayment = 'Next Payment Date'
export const repeatEvery = 'Frequency'
export const repeatsEvery = 'Frequency'
export const every = 'Every'
export const end = 'End'
export const occurrences = 'occurrence(s)'
export const paymentsSchedule = 'payments schedule'
export const myShare = 'My share'
export const scheduleExpense = 'Schedule Expense'
export const week = 'Week'
export const on = 'On'
export const expenseDetails = 'Expense Details'
export const deleteExpense = 'Delete'
export const markAsPaid = 'Mark as Paid'
export const markAsPaidDescription = 'Track payments made by check, cash or other means'
export const editExpense = 'Edit'
export const download = 'Download'
export const submittedBy = 'Submitted by'
export const paid = 'paid'
export const paidExternally = 'external'
export const digitalCheck = 'check'
export const pending = 'pending'
export const notPaid = 'unpaid'
export const rejected = 'rejected'
export const paidOn = 'Paid On'
export const due = 'Due'
export const reimburse = 'Reimburse'
export const originalPaymentPart1 = 'original'
export const originalPaymentPart2 = 'payment'
export const reimbursementPayment = 'reimbursement payment'
export const paidBy = 'Paid By'
export const origPaidBy = 'Originally paid by'
export const owedBy = 'Owed By'
export const all = 'All'
export const description = 'Description'
export const enterDescription = 'Enter Expense Description'
export const shareRatio = 'Share Ratio'
export const totalAmount = 'Total Amount'
export const totalAmountPaidBy = 'Total Amount Paid By'
export const reimbAmountBy = 'Reimbursement Paid By'
export const coparentShare = "Co-Parent's Share"
export const originalAmount = 'Original Amount'
export const reimbursementAmount = 'Reimbursement Amount'
export const reimbursementPayor = 'Reimbursement payor'
export const expenseSchedule = 'expense schedule'
export const expenseDescription = 'Expense Description'
export const yourShare = 'Your Share'
export const nextPaymentDate = 'Next Payment Date'
export const addRecurringExpense = 'Add Recurring Expense'
export const addRecurringPayment = 'Add Recurring Payment'
export const noData = 'No data matches the selected criteria'
export const noCoparentData = 'There are no Co-Parent added to your family profile. Add a Co-Parent to get started.'
export const noChildrenData = 'There are no children added to your family profile. Add a child to get started with expense tracking.'
export const selectedCoparentDoesNotHaveBankAccount = 'Selected Co-Parent has not added a bank account and is not able to receive funds'
export const yourRecurringPayment = 'Your Recurring Payment'
export const startDate = 'Start Date'
export const endDate = 'End Date'
export const autopayEnabled = 'Enabled'
export const autopayDisabled = 'Disabled'
export const paymentReferenceNumber = 'Payment reference number'
export const paymentPreviewACH = 'This payment will be sent as an ACH transfer. Typical processing time is 2-5 business days. The transaction will have Checkbook.io (our payment provder) as the source.'
export const paymentPreviewDigitalCheck = 'This payment will be delivered as a digital check to the recipient\'s email address above. They can then print it out or take a picture of it and easily deposit the check into their bank account or cash it.'
export const memo = 'Digital check Memo'
export const enterMemo = 'Enter Digital check Memo'
export const alimonyMemo = 'Alimony payment for '
export const childSupportMemo = 'Child support payment for '

// Message Center
export const messageCenter = 'Message Center'
export const newMessages = 'new messages'
export const newMessagesTitle = 'New Messages'
export const sendMessage = 'Send Message'
export const msgTxtPlaceholder = 'Your message...'

// Reports
export const reportsHeadline = 'Reports'
export const reportsExpensePayment = 'Expenses & Payments Report'
export const reportsMessage= 'Messages Report'
export const reportsExpensePaymentText= 'This report will show you the details of a scheduled payment that you may access on your dashboard or in \n' +
    'payment history that includes: if paid or unpaid, due date, payor, payee, amount due and amount paid.'
export const reportsMessageText = 'This report will show you all of your messages sent with payments to the other party or messages filtered for a specific category of payment.'
export const reportsInputSpouse = 'Spouse'
export const payPdfReport = 'PDF report'
export const payExcelReport = 'Excel report'

// Document Cabinet
export const docCabinetHeadline = 'Document Cabinet'
export const comingSoon = 'Coming soon'

// Calendar
export const calendar = 'Calendar'
export const addEvent = 'Add Event'
export const child = 'Child'
export const eventTitle = 'Event Title'
export const eventTitlePlaceholder = 'Enter Event Title'
export const additionalDescription = 'Additional Description'
export const additionalDescriptionPlaceholder = 'Enter Additional Description'
export const location = 'Location'
export const locationPlaceholder = 'Enter Location'
export const recurringEvent = 'Recurring Event'
export const repeatOn = 'Repeat On'
export const time = 'Time'
export const schedule = 'Schedule'
export const scheduleChildVisitation = 'Schedule Parenting Time'
export const eventType = 'Event Type'
export const selectEventType = 'Select Event Type'
export const applyPattern = 'Recurring Schedule'
export const exportCalendar = 'Export Calendar'
export const exportCalendarFp = 'Use this URL to import FamiliPay parenting calendar into the calendar application of your choice'
export const holidaySchedule = 'Holiday Schedule'
export const stayingWith = 'Staying with'
export const mixed = 'Mixed'
export const clearAllSelections = 'Clear All Selections'
export const yearlyVisitDistribution = 'Yearly Visitation Distribution'
export const iCalLink = 'Get public iCal link'
export const print = 'Print'
export const templatePeriod = 'Template Period'
export const schedulePeriodDuration = 'Scheduling period duration'
export const weeks = 'weeks'
export const monAbbr = 'Mon'
export const tueAbbr = 'Tue'
export const wedAbbr = 'Wed'
export const thuAbbr = 'Thu'
export const friAbbr = 'Fri'
export const satAbbr = 'Sat'
export const sunAbbr = 'Sun'
export const sureClearSelection = 'You cannot undo this action. Are you sure that you want to clear all selections'
export const monthlyCalendar = 'Monthly calendar'
export const annualCalendar = 'Annual calendar'

// Profile
export const userProfile = 'User Profile'
export const changePassword = 'Change Password'
export const name = 'Name'
export const accountCreationDate = 'Account Creation Date'
export const coParent = 'Co-Parent'
export const addCoparent = 'Add Co-Parent'
export const invite = 'Invite'
export const children = 'Children'
export const addChild = 'Add Child'
export const enterChildFirstName = 'Enter Child First Name'
export const enterChildLastName = 'Enter Child Last Name'
export const coparent = 'Co-Parents'
export const selectCoparent = 'Select Co-Parent'
export const enterCoparentFirstName = 'Enter Co-Parent First Name'
export const enterCoparentLastName = 'Enter Co-Parent Last Name'
export const enterCoparentEmail = 'Enter Co-Parent Email'
export const currentPassword = 'Current Password'
export const enterCurrentPassword = 'Enter Current Password'
export const enterNewPassword = 'Enter New Password'
export const confirmPassword = 'Confirm Password'
export const enterConfirmPassword = 'Enter Confirmed Password'
export const save = 'Save'
export const coparentsName = 'Co-Parent Name'
export const deleteAccount = 'Delete Account'
export const deleteAccountWarningTitle = 'warning: deletion is permanent'
export const deleteAccountWarningText = 'When you permanently delete account you will be logged out of FamiliPay and your account will no longer be usable.'
export const deleteAccountModalTitle = 'Are you sure you want to permanently delete your account?'
export const deleteAccountModalBtnNo = 'No, I would like to reconsider'
export const deleteAccountModalBtnYes = 'Yes, delete my account permanently'
export const familipaySolo = 'FamiliPay Solo'
export const familipayDuo = 'FamiliPay Duo'
export const familipaySoloText1 = 'FamiliPay Solo allows you to use almost all of the features of FamiliPay even if you do not invite the other co-parent to join the platform. You can still track/pay expenses and schedule time but this information will be visible only to you. You will not be able to receive money from the other party.'
export const familipaySoloText2 = "Don't worry, you can always invite them later."
export const familipayDuoText1 = 'FamiliPay Duo allows you to use the full potential of the platform. It will serve as a shared whiteboard for all of your payments, calendar and communication.  This mode allows both parties to send and receive payments through the platform. Bank account verification information is never shared with the other co-parent.'
export const sendDigitalChecks = 'I want to send digital checks to this co-parent'
export const sendDigitalChecksText1 = 'Payments to the other co-parent will be delivered as a digital check to the email address above. They can then print it out or take a picture of it and easily deposit the check into their bank account or cash it. A digital check is just like a regular physical bank check in this regard.'
export const sendDigitalChecksText2 = 'You can track the status of the invitation on the Family Profile page. Until the other co-parent accepts the invitation, you can still use all of the features of the platform. Payments to the other co-parent will be delivered as a digital check to the email address above. They can then print it out or take a picture of it and easily deposit the check into their bank account or cash it. A digital check is just like a regular physical bank check in this regard.'
export const invitationStatus = 'Invitation status'
export const eligibleToReceiveFunds = 'Can receive funds'
export const INVITATION_SENT = 'Sent'
export const INVITATION_ACCEPTED = 'Accepted'
export const INVITATION_EXPIRED = 'Expired'
export const NOT_INVITED = 'Not invited'
export const achDescription = 'ACH will be used to facilitate the transactions to this co-parent. Any payments to them will automatically settle into their bank account in 2-5 business days.'
export const digitalCheckDescription = 'Payments to the other co-parent will be delivered as a digital check. They can then print it out, deposit it through their ebanking application, or cash it.'
export const notEligableDescription = 'This parent cannot receive payments. You have to invite them (for ACH payments) or add their email address (for digital checks) in order to enable payments.'

// Payment Methods
export const personalInformation = 'Personal Information'
export const verifyPersonalInfo = 'Verify Personal Info'
export const editPersonalInfo = 'Edit Personal Info'
export const customerStatus = 'Customer Status'
export const notVerfied = 'not verified'
export const verificationRetryRequired = 'verification retry required'
export const verified = 'verified'
export const additionalDocumentsRequired = 'additional documents required'
export const additionalDocuments = 'Additional Documents are Required for Submition'
export const submitDocument = 'Submit Document'
export const addedOn = 'Added on'
export const pendingApproval = 'Pending Approval...'
export const reviewed = 'Reviewed'
export const failedApproval = 'Failed Approval'
export const expensePaymentMethods = 'Expense Payment Methods'
export const addBankAccount = 'Add Bank Account'
export const suspended = 'suspended'
export const deactivated = 'deactivated'
export const close = 'close'
export const dateOfBirth = 'Date of Birth'
export const today = 'Today'
export const address = 'Address'
export const enterAddress = 'Enter Address'
export const city = 'City'
export const enterCity = 'Enter City'
export const state = 'State'
export const enterState = 'Select State'
export const postalCode = 'Postal Code'
export const enterPostalCode = 'Enter Postal Code'
export const ssn = 'ssn'
export const lastFourDigits = '(last four digits)'
export const full = '(full)'
export const enterSsn = 'Enter SSN'
export const mandatoryFields = 'means mandatory fields'
export const back = 'Back'
export const verify = 'Verify'
export const documentType = 'Document Type'
export const uploadAttachment = 'Upload Attachment'
export const selectDocumentType = 'Select Document Type'
export const submit = 'Submit'
export const accountBalance = 'Account Balance'
export const familiPayAccountBalance = 'FamiliPay account balance'
export const bonusTransactions = 'Remaining free transactions'
export const remainingBonusTransactions = 'Free transactions after this payment'
export const cancelSubscription = 'Cancel Subscription'
export const cancelSubscriptionModalTitle = 'Are you sure you want to cancel your subscription?'
export const cancelSubscriptionModalText = ''
export const retryPayment = 'Retry Payment'
export const retryPaymentModalTitle = 'A payment will be attempted from your default card'
export const retryPaymentModalText = ''
export const retryPaymentModalBtnNo = 'Cancel'
export const retryPaymentModalBtnYes = 'Continue'
export const microDepositInfo1 = 'We have credited two small deposits to the selected bank account. Enter the amounts of the deposit below to verify the ownership of your account. It generally takes 1-2 days for the deposits to appear in your account.'
export const microDepositInfo2 = 'You can close this window and finish adding the bank account upon receiving the bank deposits.'

// Notifications
export const notifHeadline = 'Notifications'
export const markAllRead = 'Mark All Read'

// Pay Expense
export const fees = 'Fees'
export const bankAccount = 'Bank Account'
export const selectBankAccount = 'Select Bank Account'
export const managePaymentMethods = 'Manage Payment Methods'

// Base64 Upload
export const selectYourFile = 'Select your file'
export const dragAndDropTypes = 'Or drag and drop file here (JPG, PNG, GIF, PDF)'
export const selectAnotherFile = 'Select another file'

// Discussion
export const expenseDiscussion = 'Expense Discussion'
export const discuss = 'Discuss'
export const addComment = 'Add Comment'
export const comments = 'comments'
export const closed = 'closed'

// FPTable
export const view = 'View'
export const edit = 'Edit'
export const deleteTable = 'Delete'
export const show = 'Show'
export const outOf = 'out of'
export const result = 'results'
export const jumpToPage = 'Jump to page'
export const deleteMess = 'Delete'
export const makeDefault = 'Make Default'
export const resendInvitation = 'Resend Invitation'
export const sendInvitation = 'Send Invitation'
export const cancelInvitation = 'Cancel Invitation'

// Modal's names
export const addBankAccountModal = 'Add Bank Account'
export const payExpenseModal = 'Payment Preview'
export const addChildModal = 'Add Child'
export const editChildModal = 'Edit Child'
export const addCoparentModal = 'Add Co-Parent'
export const editCoparentModal = 'Edit Co-Parent Information'
export const inviteCoparentModal = 'Invite Co-Parent'
export const changePasswordModal = 'Change Password'
export const personalInfoModal = 'Edit Personal Info'
export const addCardModal = 'Add Card'
export const addCard = 'Add'

// FPTable's headers
export const coParentName = "Co-Parent's Name"
export const status = 'Status'
export const actions = 'Actions'
export const defaultMsg = 'Default'
export const accountNumber = 'Account Number'
export const type = 'Type'
export const dateAdded = 'Date Added'
export const summary = 'Summary'
export const reimbursement = 'Reimbrusement'
export const cardNumber = 'Card Number'
export const expirationDate = 'Expiration Date'
export const lastSubscriptionPaymentDate  = 'Last Subscription Payment Date'
export const nextSubscriptionPaymentDue = 'Next Subscription Payment Due'
export const subscriptionStatus = 'Subscription Status'
export const subscription = 'Subscription'
export const trialStatus = 'Trial'
export const activeStatus = 'Active'
export const pastDueStatus = 'Past due'
export const canceledStatus = 'Canceled'
export const cardVerificationMessage1 = 'FamiliPay will verify your credit cards by running $1 authorization charge and then automatically voiding it. Your first subscription payment will be charged at the end of your trial period.'
export const cardVerificationMessage2 = 'FamiliPay does not store your card information. Your card information is stored in a PCI compliant external card vault provided by Braintree, a division of PayPal.'
export const pricingTrialMessage1 = 'First'
export const pricingTrialMessage2= 'free.'
export const addBankCard = 'Add Bank Card'
export const transactionsSuspendedModal = 'Additional verification required'

// Snotify error
export const sn_genericError = 'Something went wrong...'
export const sn_invalidCredentials = 'Invalid Credentials'
export const sn_loginEmailConfirm = 'You have disabled your account, please reset your password.'
export const sn_thanksConfirm = 'Thank you for confirming your email address. You can log in with your credentials now'
export const sn_deactivation = 'Your account has been deactivated.'
export const sn_incorrectEmailPass = 'Incorrect email or/and password'
export const sn_forgetPass = 'Check your inbox, and proceed with password reset'
export const sn_forgetPassConfirm = 'You can now login'
export const sn_confirmReg = 'Account is successfully registered'
export const sn_paymentDeleted = 'Payment is successfully deleted'
export const sn_successUploadFile = 'You have successfully uploaded document'
export const sn_successPersonalInfo = 'You have successfully saved personal info'
export const sn_successPersonalInfoEdited = 'Personal Info is successfully edited'
export const sn_childAdded = 'Child is successfully added'
export const sn_childEdited = 'Child is successfully edited'
export const sn_childDelete = 'Child is successfully deleted'
export const sn_coparentAdded = 'Co-Parent is successfully added'
export const sn_coparentEdited = 'Co-Parent is successfully edited'
export const sn_coparentDeleted = 'Co-Parent is successfully deleted'
export const sn_coparentRecordWrongDate = 'You have to select a date!'
export const sn_successCoparentInvited = 'Co-Parent is successfully invited'
export const sn_successPassChanged = 'Password is successfully changed'
export const sn_succesPaidExpense = 'You have successfully pay expenses'
export const sn_paymentSuccessDelete = 'Payment is successfully deleted'
export const sn_paymentSuccesSaved = 'Payment is successfully saved'
export const sn_reportDontExist = 'There are no data for selected dates'
export const sn_conversationDontExist = 'There are no messages for selected Co-Parent'
export const sn_eventSavedSuccess = 'Event is successfully added'
export const sn_eventUpdatedSuccess = 'Event is successfully updated'
export const sn_addCardSuccess = 'Card is successfully added'
export const sn_defaultCardSuccess = 'Card is default payment method now'
export const sn_deleteCardSuccess = 'Card is successfully deleted'
export const sn_eventSuccessDelete = 'Event is successfully deleted'
export const sn_createBrainPayment = 'Currently, we cannot process your payment. Please try again later...'
export const sn_paymentSuccesMarkedAsPaid = 'Payment is successfully marked as paid'
export const sn_deleteCheckbookAccount = 'Checkbook account is successfully deleted'
export const sn_defaultCheckbookAccount = 'The selected Checkbook account is default now'
export const sn_checkbookSingleAccountError = 'You cannot delete this Checkbook account, since it\'s the last funding source'
export const sn_tooLongName = 'Both First and Last name must have less or exactly 32 characters'
export const sn_successCoparentResendInvite = 'You have successfully resend invitation to the Co-Parent'
export const sn_errorOneFileSizeLimit= 'You cannot upload file larger than 10MB.'
export const sn_errorManyFileSizeLimit= 'One of you files is larger than 10MB and cannot be uploaded.'
export const sn_invitationAccepted = 'You have successfully accepted the invitation to join the case'
export const sn_finishedRegistration = 'You have successfully completed all the registration steps'
export const sn_accountDeletedSuccess = 'You have successfully deleted your account'
export const sn_subscriptionCanceledSuccess = 'You have successfully canceled your subscription'
export const sn_retryPaymentSuccess = 'You have successfully made the payment'

// Tooltips
export const tp_dashboardTimelineTitle = 'Timeline'
export const tp_dashboardTimelineText = 'This timeline shows your payments and events in a chronological order. It allows you to get a quick view of your schedule for the next weeks.'
export const tp_dashboardMessageCenterTitle = 'Message Center'
export const tp_dashboardMessageCenterText = 'New messages from our Message Center will appear here automatically. You can dismiss them or reply instantly.'
export const tp_paymentsToPayTitle = 'Expenses to Pay'
export const tp_paymentsToPayText = 'Here you can see a list of outstanding payments owed by you. Click a payment for more information. To add a new payment or schedule recurring payment use the "Schedule payment" button from the sidebar. In order to make a payment click the "pay" button on the respective payment card.'
export const tp_paymentsToReceiveTitle = 'Expenses to Receive'
export const tp_paymentsToReceiveText = 'Here you can see a list of outstanding payments owed by the other Co-Parent. Click a "payment" for more information. To add a new payment or schedule recurring payment use the "Schedule payment" button from the sidebar.'
export const tp_alreadyPaidTitle = 'Already Paid'
export const tp_alreadyPaidText = 'Select this if the payment has already been paid.'
export const tp_recurringPaymentsTitle = 'Recurring Payments'
export const tp_recurringPaymentsText = 'This is a list of recurring payment templates. You can schedule recurring payments by clicking the "Schedule recurring payment" button.'
export const tp_autopayTitle = 'Autopay'
export const tp_autopayText = 'Select this if you want to automate payments for this expense.'
export const tp_parentingCalendarTitle = 'Parenting Calendar'
export const tp_parentingCalendarText = 'This part of the application shows your family\'s schedule including parenting time and events. Parenting time is shown as continous lines which span the entire duration of the parenting time, while single events are shown as one-day entries with an icon.'
export const tp_scheduleChildVisitationTitle = 'Schedule Parenting Time'
export const tp_scheduleChildVisitationText = 'This page allows you to easily make a parenting time schedule for an entire year. By clicking the individual date you can cycle through co-Parent. Each Co-Parent has a color which also indicates their share of the child\'s time in the bottom. In order to select multiple days you can continue draging after clicking or you can use a shift key to mark the beggining and end of their time. You can also edit the holiday schedule or apply a template to a certain part of the year by using the appropriate buttons in the top.'
export const tp_holidayScheduleTitle = 'Holiday Schedule'
export const tp_holidayScheduleText = 'This section allows you to select who spends time with the child on specific holidays. Keep in mind that selections made here will overwrite or have priority over any previously selected parenting time.'
export const tp_applyPatternTitle = 'Schedule Parenting Time Template'
export const tp_applyPatternText = 'This section allows you to define a recurring template and apply it to a parenting time period. For example, if parenting time is on a recurring two week schedule, and one Co-Parent has alternate weekends and the other Co-Parent has the other twelve overnights in those two weeks, you can select that and then template it for an entire year.  Start by selecting the period start and end date. After that select the recurring period in weeks. This will allow you to edit the individual days in the selected number of weeks. Editing works similair to the main child parenting time page where clicking the individual day cycles through Co-Parent. Once you define your pattern or template it will be repeated throughout the entire period. Keep in mind that selections made here will overwrite or have priority over the previously selected parenting time.'
export const tp_userProfileCoparentsTitle = 'Co-Parent'
export const tp_userProfileCoparentsText = 'This part of the application shows your co-parents and their information. In order to use the full potential of the application you need to invite at least one co-parent.'
export const tp_userProfileChildrenTitle = 'Children'
export const tp_userProfileChildrenText = 'This part of the application shows a list of your children and their information. In order to use parenting calendar, child support payments, and shared expense tracking you need to add at least one child.'
export const tp_bothUsersNotAbleToCreateOrRecieveTransferPart1 = 'Both you and the other Co-Parent need to set up their bank accounts on the '
export const tp_bothUsersNotAbleToCreateOrRecieveTransferPart2 = ' before being able to receive or send funds.'
export const tp_userNotAbleToCreateOrReceiveTransferPart1 = 'You have to connect your account on the '
export const tp_userNotAbleToCreateOrReceiveTransferPart2 = ' before being able to receive or send funds.'
export const tp_expenseHasPendingTransaction = 'Expense already has pending transactions'
export const tp_currentUserIsNotPayor = 'You have to be listed as a payor in order to pay an expense'
export const tp_recipientIsRecordKeepingProfile = 'Payments cannot be made to record-keeping users'
export const tp_recipientCanNotReceiveFunds = 'The Co-Parent has to connect his/her account before being able to receive or send funds.'
export const tp_paymentIsPaid = 'A payment for this expense has already been made'
export const tp_paymentsMethods = 'payments methods page'
export const tp_noEntryFound = 'No Entry Found'
export const tp_spiritTitle = 'FamiliPay Spirit™'
export const tp_spiritText = 'This icon will change  depending how we detect the communication tone. FamiliPay Spirit helps you decide if you wish to modulate your messages in the spirit of co-parenting.'

// Validations tooltips
export const vee_dateFromBeforeDateTo = 'Date From must be before Date To'
export const vee_dateStartBeforeEndDate = 'Start Date must be before End Date'
export const vee_selectValidField = 'Please select valid'
export const vee_the = 'The'
export const vee_requiredField = 'field is required'
export const vee_tos = 'Please agree to terms of service'
export const vee_eventTime = 'Event Time'
export const vee_dateInThePast = ' should be a date in the past'
export const vee_olderThan18 = 'You have to be 18 or older'

// Delete Modal
export const deleteModalTitle = 'Delete ITEM?'
export const deleteModalBody = 'Deleting this ITEM will permanently remove all information associated with it.'
export const deleteModalNoBtn = 'No, keep ITEM'
export const deleteModalYesBtn = 'Yes, delete ITEM'

// NLP Modal
export const nlp_title = 'Confirm message'
export const nlp_body = 'We have detected some negative sentiment in your message. Are you sure you want to send this message'
export const nlp_confirm = 'Yes, I want to send it'

// Preferences
export const preferences_welcome = 'Welcome to FamiliPay'
export const preferences_welcome_title = ', world’s best co-parenting payment platform!'
export const preferences_welcome_text = 'We are overwhelmingly regarded as #1 by co-parents and the legal community in the US and Europe. Alimony, child support, and shared expense payments are all managed for you by FamiliPay.   '
export const preferences_continue = 'Continue'
export const preferences_payment_title = 'Payment Types'
export const preferences_payments_text = 'Which of the following payments are made by you or your co-parent?'
export const preferences_payments_paying = 'paying'
export const preferences_payments_receiving = 'receiving'
export const preferences_payments_alimony_child_description = 'We’ll add alimony and child support payments to your setup checklist. You can add shared payments at any time in the future if needed.'
export const preferences_payments_shared_expenses_description = 'When paying ‘shared expenses’ in FamiliPay, there is always one parent who pays the expense and one parent who reimburses their share of the expense.  For example, music lessons for $40 a week.  You will pay the teacher $40 and then your co-parent will reimburse you their share e.g. 50% is $20.'
export const preferences_next = 'Next'
export const preferences_parenting_schedule_title = 'Parenting Schedule'
export const preferences_parenting_schedule_text = 'In addition to managing all of your co-parenting payments, FamiliPay supports a full features co-parenting calendar system.  It allows you to manage the holiday, weekend, and summer parenting schedules.'
export const preferences_parenting_schedule_question = 'Would you be interested in using the FamiliPay co-parent scheduling feature?'
export const preferences_yes = 'Yes'
export const preferences_no = 'No'
export const preferences_parenting_schedule_ok_got_it = 'Ok, got it!'
export const preferences_parenting_schedule_description = 'You can choose to use the co-parent scheduling feature anytime. We just won\'t include it in your initial setup steps.'
export const preferences_parenting_schedule_tip = 'Tip: '
export const preferences_finish = 'Finish'

// Registration progress
export const registration_progress_btn_got_it_1 = 'Ok, got it'
export const registration_progress_btn_got_it_2 = 'Ok, got it. Take me to the next step'
export const registration_progress_step_1 = 'Click here and follow instructions to add a co-parent to your profile. If you decide to invite them to FamiliPay, this will allow them to track, receive and send payments'
export const registration_progress_step_2  = 'Click here and follow instructions to add a child to your profile'
export const registration_progress_coparent_added = 'Great! You have added co-parent. Note that you can add or invite another co-parent by clicking on Add Co-parent button'
export const registration_progress_child_added = 'Great! You have successfully added a child to your profile. You can add more children by clicking the Add Child button'
export const registration_progress_step_3 = 'Click here and follow instructions to add a card for paying your FamiliPay subscription. You will be charged monthly after the end of your 3 month trial period'
export const registration_progress_step_4 = 'You will need to verify personal info in order to continue your profile setup. You can verify your personal information just by clicking here on ‘Verify Personal Info’ button'
export const registration_progress_step_5 = 'In order to add a bank account, you just need to click here'
export const registration_progress_bank_account_added = 'Great! You have added a bank account. In order to add another bank account, you just need to click on ‘Add Bank Account’ button'
export const registration_progress_schedule_payment = 'Click here at any time you want to add a new payment'
export const registration_progress_calendar = 'Access your shared parenting schedule here. Use recurring patterns and holiday schedules to easily plan your children\'s time'
export const registration_progress_schedule_payment_calendar = 'Click here at any time you want to add a new payment or you want to access your shared parenting schedule. Use recurring patterns and holiday schedules to easily plan your children\'s time'
export const registration_progress_subscription_activated = 'You have succesfully linked your card and activated your :duration :durationUnit free trial period'
export const registration_progress_btn_skip = 'Skip adding bank account for now'